module.exports = __webpack_public_path__ + "img/13d.2e109512.jpg";